import React from "react";
import { Button, Form, FormGroup, Input, Label, Alert, Spinner } from "reactstrap";
import axios from "axios";
import { API_URL_vendors } from "../../constants";

import { getAuthHeaders } from "../../utils/auth";
class NewVendorForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pk: '',
      vendor: "",
      errorMessage: '',
      validationErrors: {},
      isSubmitting: false,
    };
  }

  componentDidMount() {
    if (this.props.vendor) {
      const { pk, vendor } = this.props.vendor;
      this.setState({ pk, vendor });
    }
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  validateForm = () => {
    const errors = {};
    const { vendor } = this.state;

    if (!vendor || vendor.trim() === '') {
      errors.vendor = 'Por favor ingresa el nombre del vendedor';
    }

    this.setState({ validationErrors: errors });
    return Object.keys(errors).length === 0;
  };

  createVendor = e => {
    e.preventDefault();

    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    const headers = getAuthHeaders();
    axios.post(API_URL_vendors, this.state, { headers })
      .then(() => {
        this.props.resetState();
        this.props.toggle();
      })
      .catch(error => {
        console.error("Error adding vendor:", error.response?.data);
        if (error.response?.data) {
          const serverErrors = error.response.data;
          if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
            this.setState({ validationErrors: serverErrors, isSubmitting: false });
          } else {
            this.setState({
              errorMessage: 'Error al crear el vendedor. Por favor verifica los datos.',
              isSubmitting: false
            });
          }
        } else {
          this.setState({
            errorMessage: 'Error de conexión. Por favor intenta nuevamente.',
            isSubmitting: false
          });
        }
      });
  };

  editVendor = e => {
    e.preventDefault();

    if (!this.validateForm()) {
      this.setState({ errorMessage: 'Por favor completa todos los campos obligatorios marcados con *' });
      setTimeout(() => {
        const firstError = document.querySelector('.is-invalid');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus();
        }
      }, 100);
      return;
    }

    this.setState({ isSubmitting: true, errorMessage: '' });

    const headers = getAuthHeaders();
    axios.put(API_URL_vendors + this.state.pk, this.state, { headers })
      .then(() => {
        this.props.resetState();
        this.props.toggle();
      })
      .catch(error => {
        console.log(error);
        if (error.response?.data) {
          const serverErrors = error.response.data;
          if (typeof serverErrors === 'object' && !Array.isArray(serverErrors)) {
            this.setState({ validationErrors: serverErrors, isSubmitting: false });
          } else {
            this.setState({
              errorMessage: 'Error actualizando el vendedor. Por favor verifica los datos.',
              isSubmitting: false
            });
          }
        } else {
          this.setState({
            errorMessage: 'Error de conexión. Por favor intenta nuevamente.',
            isSubmitting: false
          });
        }
      });
  };

  defaultIfEmpty = value => {
    return value === "" ? "" : value;
  };

  render() {
    const { errorMessage, validationErrors, isSubmitting } = this.state;

    return (
      <Form onSubmit={this.props.vendor ? this.editVendor : this.createVendor}>
        <p style={{ fontSize: '0.9em', color: '#007bff', marginBottom: '1rem' }}>
          Los campos marcados con <span style={{ color: 'red' }}>*</span> son obligatorios
        </p>

        <FormGroup>
          <Label for="vendor">Vendor Name: <span style={{ color: 'red' }}>*</span></Label>
          <Input
            type="text"
            name="vendor"
            onChange={this.onChange}
            value={this.defaultIfEmpty(this.state.vendor)}
            invalid={!!validationErrors.vendor}
          />
          {validationErrors.vendor && (
            <div className="invalid-feedback d-block">{validationErrors.vendor}</div>
          )}
        </FormGroup>

        {errorMessage && <Alert color="danger">{errorMessage}</Alert>}

        <Button color="primary" disabled={isSubmitting}>
          {isSubmitting ? (
            <>
              <Spinner size="sm" className="me-2" /> Guardando...
            </>
          ) : (
            this.props.vendor ? "Actualizar Vendedor" : "Crear Vendedor"
          )}
        </Button>
      </Form>
    );
  }
}

export default NewVendorForm;
